import { type SupportedLocale } from '@zep-us/i18n';

/**
 * 이미지·샘플보드·가이드가 실제로 준비된 로케일. 그 외 로케일은 전부 en 으로
 * 떨어진다. 이미지/링크 맵이 이 타입을 Record 키로 쓰므로 로케일을 늘릴 때
 * 준비되지 않은 맵이 타입 에러로 같이 잡힌다.
 */
export type BoardLandingContentLocale = 'ko' | 'ja' | 'id' | 'th' | 'en';

const FALLBACK_LOCALE = 'en';

const CONTENT_LOCALES: readonly BoardLandingContentLocale[] = [
  'ko',
  'ja',
  'id',
  'th',
  'en',
];

export function resolveContentLocale(
  locale: SupportedLocale,
): BoardLandingContentLocale {
  return CONTENT_LOCALES.includes(locale as BoardLandingContentLocale)
    ? (locale as BoardLandingContentLocale)
    : FALLBACK_LOCALE;
}
